import { useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../lib/supabaseClient";

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    if (!password || password.length < 6) {
      setStatus("Password must be at least 6 characters.");
      setLoading(false);
      return;
    }

    const { error } = await supabase.auth.updateUser({ password });

    if (error) {
      setStatus(error.message);
    } else {
      setStatus("Password updated. You can now sign in.");
    }

    setLoading(false);
  }

  return (
    <div className="max-w-md mx-auto bg-white p-6 rounded-lg shadow">
      <h1 className="text-xl font-bold mb-2">Set a new password</h1>
      <p className="text-sm text-gray-600 mb-4">
        Choose a new password for your account.
      </p>

      <form onSubmit={onSubmit} className="space-y-3">
        <input
          type="password"
          className="w-full border rounded px-3 py-2"
          placeholder="New password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="new-password"
        />

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-sabre-blue text-white rounded py-2 disabled:opacity-50"
        >
          {loading ? "Saving..." : "Update password"}
        </button>

        {status && <div className="text-sm text-gray-700">{status}</div>}
      </form>

      <p className="text-sm text-gray-600 mt-4">
        <Link to="/privacy" className="underline hover:text-gray-800">
          Privacy Notice
        </Link>
      </p>
    </div>
  );
}
